import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const profileGalleryDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_ProfileGallery: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_ProfileGallery: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
